import Collection from './../../common/Collection';
import DayInRacing from './DayInRacing';

class DaysInRacing extends Collection {

	constructor() {
		super();
		this.endpoint = '/api/node.json';
		this.model = DayInRacing;
		this.arguments = {
			parameters: {
				type: 'day_in_racing'
			},
			sort: 'field_date',
			direction: 'asc',
			pagesize: 100
		};
	}

	static className() {
		return 'DaysInRacing';
	}

}

export default DaysInRacing;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/DaysInRacing.js
 **/